// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-role_select-role-card__pvzn1 {
  border-radius: 6px;
  padding: 24px;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 12px;
  align-items: center;
  cursor: pointer;
  text-decoration: none;
  background-color: white;

  &:hover {
    box-shadow: var(--shadow-high);
  }
}

.select-role_select-role-content__\\+LCNT {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  flex-direction: column;
}
`, "",{"version":3,"sources":["webpack://./src/components/register/select-role.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,uBAAuB;;EAEvB;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,sBAAsB;AACxB","sourcesContent":[".select-role-card {\n  border-radius: 6px;\n  padding: 24px;\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 12px;\n  align-items: center;\n  cursor: pointer;\n  text-decoration: none;\n  background-color: white;\n\n  &:hover {\n    box-shadow: var(--shadow-high);\n  }\n}\n\n.select-role-content {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n  flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"select-role-card": `select-role_select-role-card__pvzn1`,
	"select-role-content": `select-role_select-role-content__+LCNT`
};
export default ___CSS_LOADER_EXPORT___;
